const baseUrl = '/conta-institucional'; 

const urls = {
    home:    { name: 'Home',    path:'/'},
    change:  { name: 'Change',  path:'/change-password'},
    choices: { name: 'Choices', path:'/account-choices'},
    exists:  { name: 'Exists',  path:'/account-already-exist'},
    created: { name: 'Created', path:'/account-created'}
};

export {baseUrl, urls};